import {createAction} from '@reduxjs/toolkit';

const CLEAN_CHANGE_REQUEST_REVIEW = 'CLEAN_CHANGE_REQUEST_REVIEW';

export const cleanChangeRequestReview = createAction(CLEAN_CHANGE_REQUEST_REVIEW);
